import { ModuleWithProviders, NgModule } from '@angular/core';
import { F3ConfigService } from '@f3/services/config/config.service';
import { F3_APP_CONFIG } from '@f3/services/config/config.constants';

@NgModule()
export class F3ConfigModule
{
    /**
     * Constructor
     */
    constructor(
        private _f3ConfigService: F3ConfigService
    ) { }

    /**
     * forRoot method for setting user configuration
     *
     * @param config
     */
    static forRoot(config: any): ModuleWithProviders<F3ConfigModule>
    {
        return {
            ngModule : F3ConfigModule,
            providers: [
                {
                    provide : F3_APP_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
